import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { HomeLabelConstant } from 'src/app/constants/LabelMessages';
import { CommonService } from 'src/app/services/common/common.service';
import { LoaderChangeService } from 'src/app/services/loader/loader-change.service';
import { SharedService } from 'src/app/services/shared-service/shared.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  
  labelConstant: any;
  previousUrl: string;

  constructor(
    private commonService: CommonService,
    private sharedService: SharedService,
    private router: Router,
    private spinnerService : LoaderChangeService

  ) { }

  ngOnInit() {
    this.labelConstant = HomeLabelConstant;
    this.sharedService.setData("Home");
    this.spinnerService.setLoaderMessage({})
    this.commonService.setBannerData('');

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        // Store the previous route URL
        this.previousUrl = this.router.url;
        if(this.previousUrl.split("/")[2] == "paymentsuccess"){
          this.router.navigate(['/']);
        }
      }
    });
  }
}
